import { transformNewbuildingsForPromoSlider } from '../../mappers/transformNewbuildingsForPromoSlider';
import {
  fetchGetNewbuildingsForBuildersPromoSlider,
  TGetNewbuildingsForBuildersPromoSliderResponse,
} from '../../repositories/newbuilding-search/v1/get-newbuildings-for-builders-promo-slider';
import { IApplicationContext } from '../../types/applicationContext';
import { INewbuildingsForPromoSliderResponse } from '../../types/newbuildingsForPromoSlider';
import { ResponseError } from '../../utils/errors';

export interface IGetNewbuildingsForPromoSliderParameters {
  newbuildingIds: number[];
}

export async function getNewbuildingsForPromoSlider(
  context: IApplicationContext,
  parameters: IGetNewbuildingsForPromoSliderParameters,
): Promise<INewbuildingsForPromoSliderResponse> {
  const { httpApi, logger } = context;

  try {
    const response = await fetchGetNewbuildingsForBuildersPromoSlider<
      TGetNewbuildingsForBuildersPromoSliderResponse,
      TGetNewbuildingsForBuildersPromoSliderResponse
    >({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'shared.services.getNewbuildingsForPromoSlider()',
        message: response.response.message as string,
      });
    }

    return transformNewbuildingsForPromoSlider(response.response);
  } catch (error) {
    logger.error(error);

    return { newbuildings: [] };
  }
}
